import React from 'react';
import moment from 'moment';
import cn from 'classnames';
import { views } from '../../constants/views';
import ChangeSheetButton from '../ChangeSheetButton/ChangeSheetButton';
import { ReactComponent as LeftIcon } from '../../../../resource/LeftIcon.svg';
import { ReactComponent as RightIcon } from '../../../../resource/RightIcon.svg';
import { useCalendarState } from '../../context/CalendarContext';
import styles from './CalendarCurrentDate.module.scss';

const CalendarCurrentDate = ({ rootClassName }) => {
  const { calendarSheet, view } = useCalendarState();

  const dates = {
    [views.month]: calendarSheet?.format('MMMM YYYY'),
    [views.week]: `${calendarSheet
      ?.clone()
      .startOf('week')
      .format('D MMMM YYYY')} - ${calendarSheet
      ?.clone()
      .endOf('week')
      .format('D MMMM YYYY')}`,
    [views.day]: calendarSheet?.format('D MMMM YYYY, ddd'),
  };

  return (
    <div className={cn(styles.root, rootClassName)}>
      <ChangeSheetButton
        icon={<LeftIcon />}
        period={calendarSheet?.clone().subtract(1, view)}
        className={styles.button}
      />
      <p
        className={cn(styles.date, {
          [styles.currentDate]:
            view === views.day && calendarSheet?.isSame(moment(), 'day'),
        })}
      >
        {dates[view] || ''}
      </p>
      <ChangeSheetButton
        icon={<RightIcon />}
        period={calendarSheet?.clone().add(1, view)}
        className={styles.button}
      />
    </div>
  );
};

export default CalendarCurrentDate;
